import DropdownToggle from "components/dropdown-toggle/DropdownToggle";
import moment from "moment-timezone";
import { useMemo } from "react";
import { Dropdown } from "react-bootstrap";
import getClasses from "utils/getClasses";
import { ZONE_NAMES } from "./constants/zone-names";
import styles from "./TimezoneDropdown.module.scss";

type Props = {
  value: string;
  onApply: (arg: string) => void;
  className?: string;
};
const TimezoneDropdown = ({ value, onApply, className }: Props) => {
  const title = useMemo(
    () => moment.tz.zone(value)?.abbr(+new Date()) || "",
    [value],
  );
  return (
    <DropdownToggle
      className={getClasses("primary", styles["timezone-dropdown"], className)}
      title={title}
      hideCaret
      variant="link"
    >
      {ZONE_NAMES.map((el) => (
        <Dropdown.Item
          key={el}
          className={styles["timezone-dropdown__item"]}
          onClick={() => onApply(el)}
        >
          {el}
        </Dropdown.Item>
      ))}
    </DropdownToggle>
  );
};

export default TimezoneDropdown;
